import { twMerge } from 'tailwind-merge';

export interface ToggleButtonOption {
  value: string;
  label: string;
}

export interface ToggleButtonGroupProps {
  options: ToggleButtonOption[];
  selected: string;
  onChange: (value: string) => void;
  label?: string;
  disabled?: boolean;
  variant?: 'primary' | 'warning';
}

export function ToggleButtonGroup({
  options,
  selected,
  onChange,
  label,
  disabled = false,
  variant = 'primary',
}: ToggleButtonGroupProps) {
  const getSelectedStyles = () => {
    if (variant === 'warning') {
      return 'bg-amber-500 text-white shadow-md';
    }
    return 'bg-primary text-white shadow-md';
  };

  return (
    <div className='flex items-center gap-4'>
      {label && (
        <span className='text-sm font-medium text-gray-900 font-inter'>
          {label}
        </span>
      )}
      <div className='inline-flex rounded-full bg-gray-100 p-1'>
        {options.map((option) => {
          const isSelected = selected === option.value;
          return (
            <button
              key={option.value}
              type='button'
              disabled={disabled}
              onClick={() => onChange(option.value)}
              className={twMerge(
                'inline-flex items-center gap-1.5 rounded-full px-4 py-1.5 text-sm font-medium font-inter transition-all duration-200 ease-in-out',
                isSelected
                  ? getSelectedStyles()
                  : 'text-gray-600 hover:text-gray-900 hover:bg-gray-50',
                disabled && 'cursor-not-allowed opacity-50'
              )}
            >
              {option.label}
            </button>
          );
        })}
      </div>
    </div>
  );
}
